<app-header id = 'rootHead'></app-header>
<router-outlet></router-outlet>
<app-footer id = 'rootFoot'></app-footer>